<div class="ab-list-item-inner flex w-100 activity-type--apply-followup-flag">
  <span class="ab-list-item__icon">
    <i class="icon fas fa-flag"
       *ngIf="item.name === EVENT_NAMES.CreateFollowUp"></i>
    <i class="icon fas fa-flag"
       *ngIf="item.name === EVENT_NAMES.ReassignFollowUp"></i>
    <i class="icon fal fa-user" *ngIf="item.name === EVENT_NAMES.ReassignFollowUp"></i>
    <i class="icon fal fa-flag-checkered"
       *ngIf="item.name === EVENT_NAMES.CompleteFollowUp"></i>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span>
      <span *ngIf="item.name === EVENT_NAMES.CompleteFollowUp"> completed a followup flag for
        <app-activity-target-link [target]="item.target"> {{item?.target | fullName}}</app-activity-target-link>
      </span>
      <span *ngIf="item.name === EVENT_NAMES.CreateFollowUp"> added a followup flag to
        <app-activity-target-link [target]="item.target"> {{item?.target | fullName}}</app-activity-target-link>
      </span>
      <ng-container *ngIf="item.name === EVENT_NAMES.ReassignFollowUp">
        <span> reassigned a followup flag for entity </span>
        <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link>
        <span> from <strong>{{item?.payload?.followUp?.previousAssignedUser | fullName }}</strong> to <strong>{{item?.payload?.followUp?.assignedUser | fullName }}</strong> </span>
      </ng-container>
    </div>
    <div class="details">
      <app-clipped-note [text]="item.payload?.note?.text || item.payload?.followUp?.note?.text"
                        [showFullText]="showFullText"
                        (showFullTextChange)="setShowFullText($event)">
      </app-clipped-note>
      <div class="mt-0075 pt-0050 border-1 border-left-0 border-bottom-0 border-right-0"
           *ngIf="item.payload?.followUp?.dueDate">
        <i class="far fa-hourglass txt-12 mr-0050 color--gray"></i>
        <strong class="caps txt-12 mr-0025 color--gray--01">Due {{item.payload?.followUp?.dueDate | relativeDate}}</strong>
        <span class="color--gray caps txt-12">({{item.payload?.followUp?.dueDate | date:'shortDate'}})</span>
      </div>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
